import type { RuleActionsStep } from "@redotech/redo-flows-common/rules/schemas";
import { useTranslation } from "@redotech/redo-i18n";
import PlayIcon from "@redotech/redo-icons/play-circle_filled.svg";
import { RedoFeaturedIcon } from "@redotech/redo-web/arbiter-components/featured-icon/redo-featured-icon";
import { Flex } from "@redotech/redo-web/flex";
import { Handle, Position } from "@xyflow/react";
import { memo } from "react";
import { PartialWithRequiredType } from "../../steps";
import { BaseNode } from "../base-node";
import * as NodeCSS from "../node.module.css";
import { getRuleActionsSummary } from "./rule-node-summary";
import { RuleNodeSummaryText } from "./rule-node-summary-text";

export interface RuleActionsNodeData {
  step: PartialWithRequiredType<RuleActionsStep>;
  deleteElements: (id: string) => void;
  hovered?: boolean;
}

export const RuleActionsNode = memo(function RuleActionsNode({
  id,
  data,
  selected,
}: {
  id: string;
  data: RuleActionsNodeData;
  selected?: boolean;
}) {
  const { t } = useTranslation();
  const summary = getRuleActionsSummary(data.step.actions);

  return (
    <>
      <Handle position={Position.Top} type="target" />
      <BaseNode
        hovered={data.hovered}
        icon={
          <RedoFeaturedIcon
            color="success"
            Icon={PlayIcon}
            shape="circle"
            size="md"
          />
        }
        onDelete={() => data.deleteElements(id)}
        selected={selected}
        step={data.step}
        title={t("Action")}
      >
        <Flex className={NodeCSS.fullInput} dir="column" gap="none">
          <RuleNodeSummaryText summary={summary} />
        </Flex>
      </BaseNode>
      <Handle position={Position.Bottom} type="source" />
    </>
  );
});
